import { Component, Input } from "@angular/core";
import { CandidateMeetingModel } from "../../../interviews.models";
import { DateService } from "src/app/services/date.service";
import { TalosDateInfo } from "src/app/models/dateinfo/talos-date-info";

@Component({
    selector: 'interview-time-widget',
    templateUrl: './interview-time-widget.component.html',
    standalone: false
})
export class InterviewTimeWidgetComponent {
  @Input() disabled: boolean = false;
  @Input() meeting?: Partial<CandidateMeetingModel>;

  constructor(public dateService: DateService) {
  }

  public formatMeetingTime(date: TalosDateInfo) {
    return this.dateService.formatTime(date);
  }
}
